module.exports = __webpack_public_path__ + "img/06.6cdd0495.png";